/** Route de vérification d'identité pour le profil actif, déduite du chemin courant. */
export function getIdentityVerificationPath(pathname: string): string | null {
  if (pathname.startsWith("/patient")) return "/patient/verification-identite";
  if (pathname.startsWith("/pro/dashboard")) return "/pro/dashboard/verification-identite";
  if (pathname.startsWith("/etablissement/dashboard")) return "/etablissement/dashboard/verification-identite";
  return null;
}
